<script>
    import { faEdit, faPen, faSave } from "@fortawesome/free-solid-svg-icons";
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";
    import Button from "./ui/Button.svelte";

    export let title;
    export let disabled = false;
    let editing = false;

    const dispatch = createEventDispatcher();
</script>


<section>
    <div class="section-heading">
        <h1>{title}</h1>
        <slot name="button">
        </slot>
        {#if editing}
            <Button intent="primary" on:click={() => {dispatch("save"); editing = false}}>
                <Fa
                    slot="icon"
                    icon={faSave}
                />
                Speichern
            </Button>
            {:else}
            <Button intent="secondary" {disabled} on:click={() => {dispatch("edit"); editing = true}}>
                <Fa
                    slot="icon"
                    icon={faPen}
                />
                Bearbeiten
            </Button>
        {/if}
    </div>
    {#if editing}
        <slot name="edit"></slot>
    {:else}
        <slot name="view"></slot>
    {/if}
</section>


<style>
    .section-heading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1.5rem;
        gap: 1rem;
        height: 2rem;
    }

    h1 {
        margin: 0;
    }

    /* the following styles should probably be global */

    h1 {
        color: rgba(0, 0, 0, 0.8);
    }

    section {
        padding: 2rem 0 3rem;
    }

    .section-heading>button {
        color: #666;
        background-color: #F0F0F0;
        border: transparent;
        border-radius: 0.5rem;
        padding: 0 1rem;
        line-height: 2rem;
        margin: 0;
    }

    .section-heading>button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .section-heading>.save {
        background-color: rgb(11, 97, 255);
        color: white;
    }
</style>